import { ShieldCheck } from 'lucide-react';

interface Props {
  institution?: string | null;
  className?: string;
}

export function InstitutionBadge({ institution, className = '' }: Props) {
  if (!institution?.trim()) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-makhe-primary/10 px-2.5 py-0.5 text-[11px] font-medium text-makhe-primary ${className}`}
    >
      <ShieldCheck size={12} aria-hidden />
      {institution} · verified student
    </span>
  );
}
